import { render, staticRenderFns } from "./ListDimension.vue?vue&type=template&id=52087516"
import script from "./ListDimension.vue?vue&type=script&lang=js"
export * from "./ListDimension.vue?vue&type=script&lang=js"
import style0 from "./ListDimension.vue?vue&type=style&index=0&id=52087516&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports